import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  TextField,
  FormControl,
  useMediaQuery,
  Grid,
  Pagination,
  Alert,
  AlertTitle,
} from "@mui/material";
import CommonModal from "./HWSubmitModal";
import SpeechBubble from "../assets/Speech bubble.svg";
import LayoutWithIcons from "./LayoutWithIcons";
import { useCharactersContext } from "../hooks/Context";

interface Question {
  updatedBy: string;
  question: string;
  mediaUrl: string;
  difficultyLevel: string;
  answerType: number;
  active: boolean;
  marks: number;
  updatedDate: string;
  subjectId: number;
  questionBankId: number;
  classId: number;
  createdDate: string;
  createdBy: string;
  optionsList: any[];
  questionPaperId: number;
  uiType: number;
  remarks: string;
}

interface Layout15Props {
  Questions: Question[];
  sectionName: string;
}

interface QuestionState {
  questionIndex: number;
  draggedWord: string | null;
  droppedArticle: string | null;
}

const Layout15: React.FC<Layout15Props> = ({ Questions, sectionName }) => {
  //console.log("Layout14Questions", Questions);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const currentQuestion = Questions[currentQuestionIndex];
  const sentences = currentQuestion?.question.split("<br>");
  //console.log("Current Question", currentQuestion);
  const questionText1 = sentences[0];
  const questionText2 = sentences[1];
  const letters = sentences[2];
  // console.log("Letters", letters);
  const lettersArray = letters.split("");
  // console.log("Letters", lettersArray.length);
  const isG25Letters = lettersArray.length > 25;
  // const shuffledLetters = [...lettersArray].sort(() => Math.random() - 0.5);
  // const shuffledLetters = useRef(
  //   [...lettersArray].sort(() => Math.random() - 0.5)
  // ).current;
  const [shuffledLetters, setShuffledLetters] = useState<string[]>([]);
  const [showAlert, setShowAlert] = useState(false);
  const handleAlertClose = () => setShowAlert(false);
  setTimeout(handleAlertClose, 3000);

  useEffect(() => {
    // Shuffle the letters randomly whenever the current question changes
    const newShuffledLetters = [...lettersArray].sort(
      () => Math.random() - 0.5
    );
    setShuffledLetters(newShuffledLetters);
  }, [currentQuestionIndex]);

  const options = currentQuestion?.optionsList[0].option
    .split(",")
    .map((option: string) => option.trim());
  //console.log("options: ", options);

  //console.log("options: ", options);
  // const rows = [];
  // const lettersPerRow = 10; // Number of letters per row
  // for (let i = 0; i < shuffledLetters.length; i += lettersPerRow) {
  //   rows.push(shuffledLetters.slice(i, i + lettersPerRow));
  // }
  const rowSize = 10;
  const rows: string[][] = [];
  for (let i = 0; i < shuffledLetters.length; i += rowSize) {
    rows.push(shuffledLetters.slice(i, i + rowSize));
  }

  const [modalOpen, setModalOpen] = useState(false);
  // const [inputValues, setInputValues] = useState<string[]>([]);
  const [inputValues, setInputValues] = useState<string[]>(() => {
    const storageKey = `inputValuesLayout15_${currentQuestion.questionPaperId}`;
    const savedState = localStorage.getItem(storageKey);
    return savedState
      ? JSON.parse(savedState)
      : Array(Questions.length).fill("");
  });
  const [isCorrectSubmission, setIsCorrectSubmission] = useState<
    boolean | null
  >(null);

  const handleInputChange = (value: string, index: number) => {
    setInputValues((prevValues) => {
      const updatedValues = [...prevValues];
      updatedValues[index] = value;
      return updatedValues;
    });
  };

  const {
    questionScores,
    setQuestionScores,
    isViewMode,
    examAnswers,
    setExamAnswers,
  } = useCharactersContext();

  const handleFormSubmit = () => {
    setShowAlert(true);
    let enteredWord = inputValues[currentQuestionIndex] || "";

    const correctAnswer = options.includes(",")
      ? options.split(",")
      : [options];

    const isEnteredWordCorrect = correctAnswer[0].includes(
      enteredWord.toUpperCase()
    );

    setIsCorrectSubmission(isEnteredWordCorrect);

    if (isEnteredWordCorrect) {
      // playCorrectSound();
      const questionIndex = questionScores.findIndex(
        (item) => item.questionBankId === currentQuestion.questionBankId
      );

      if (questionIndex !== -1) {
        // Update the existing score
        const updatedScores = [...questionScores];

        updatedScores[questionIndex] = {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: currentQuestion.marks,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        };
        setQuestionScores(updatedScores);
      } else {
        // Add a new score for the question
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else {
      // playInCorrectSound();
      setQuestionScores((prevScores) => [
        ...prevScores,
        {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: 0,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        },
      ]);
    }

    setModalOpen(true);

    const updatedExamAnswer = {
      examId: 0,
      questionBankId: currentQuestion.questionBankId,
      acutalOptionValue: correctAnswer.join(","),
      enteredOptionValue: enteredWord,
    };

    // Reset selectedOptions for the next question
    enteredWord = "";

    // Check if there is already an answer for the current question
    const existingAnswerIndex = examAnswers.findIndex(
      (answer) => answer.questionBankId === currentQuestion.questionBankId
    );

    if (existingAnswerIndex !== -1) {
      // If an answer already exists, update the existing one
      setExamAnswers((prevAnswers) =>
        prevAnswers.map((answer, index) =>
          index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
        )
      );
    } else {
      // If there is no existing answer, add the new answer
      setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
    }

    //console.log("updatedExamAnswer ", updatedExamAnswer);
    //console.log("examAnswers  ", examAnswers);
  };

  const playCorrectSound = () => {
    const correctSound = new Audio(
      require("../assets/correct-choice-43861.mp3")
    );
    correctSound.play();
    handleOpen();
  };

  const playInCorrectSound = () => {
    const incorrectSound = new Audio(
      require("../assets/wronganswer-37702.mp3")
    );
    incorrectSound.play();
    handleOpen();
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleContinue = () => {
    setCurrentQuestionIndex((prevIndex) =>
      Math.min(prevIndex + 1, Questions.length - 1)
    );
    setModalOpen(false);
  };

  const handleNavigate = (direction: "previous" | "next") => {
    if (direction === "previous") {
      setCurrentQuestionIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (direction === "next") {
      setCurrentQuestionIndex((prevIndex) =>
        Math.min(prevIndex + 1, Questions.length - 1)
      );
    }
  };

  const handleRetry = () => {
    setInputValues([]);
    setModalOpen(false);
  };
  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentQuestionIndex(value - 1);
  };

  useEffect(() => {
    const storageKey = `inputValuesLayout15_${currentQuestion.questionPaperId}`;
    localStorage.setItem(storageKey, JSON.stringify(inputValues));
  }, [inputValues]);

  useEffect(() => {
    if (isViewMode) {
      const options = currentQuestion?.optionsList[0].option;
      //("Options view mode", options);
      const correctAnswers = options;

      setInputValues(Array(Questions.length).fill(correctAnswers));
    }
  }, [currentQuestion]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "auto",
        marginTop: isTablet ? "10%" : "auto",
      }}
    >
      {/* <CommonModal
        open={modalOpen}
        isCorrectSubmission={isCorrectSubmission}
        handleContinue={handleContinue}
        handleRetry={handleRetry}
        handleClose={handleClose}
      /> */}
      {showAlert && (
        <Alert
          severity="success"
          variant="filled"
          sx={{
            position: "fixed",
            top: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            padding: "0.5",
          }}
        >
          <AlertTitle sx={{ color: "white" }}>Answer submitted</AlertTitle>
        </Alert>
      )}
      <LayoutWithIcons onNavigate={handleNavigate}>
        {currentQuestion && (
          <Card
            variant="outlined"
            sx={{
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  paddingBottom: "0px",
                }}
                style={{ userSelect: "none" }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: isMobile ? "100%" : "110%",
                    m: "1",
                  }}
                >
                  {questionText1}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: isMobile ? "100%" : "110%",
                    m: "1vh",
                  }}
                >
                  {questionText2}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "px",
                  }}
                >
                  <img
                    src={SpeechBubble}
                    alt="SpeechBubble"
                    width={isMobile ? "270vh" : "250vh"}
                    height={isMobile ? "250vh" : "200vh"}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      width: "100%",
                      marginLeft: "1em",
                      marginTop: isG25Letters
                        ? isMobile
                          ? "-11em" // Set the value for both isG25Letters and isMobile true
                          : "-9em" // Set the value for isG25Letters true and isMobile false
                        : isMobile
                        ? "-10em" // Set the value for isG25Letters false and isMobile true
                        : "-8em", // Set the value for both isG25Letters and isMobile false
                      zIndex: 1,
                    }}
                  >
                    {rows.map((row, rowIndex) => (
                      <Box
                        key={rowIndex}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {row.map((letter, letterIndex) => (
                          <Typography
                            key={letterIndex}
                            sx={{
                              fontSize: "12px",
                              color: "white",
                              padding: "2px",
                            }}
                          >
                            {letter}
                          </Typography>
                        ))}
                      </Box>
                    ))}
                  </Box>
                </Box>
                <FormControl
                  sx={{
                    marginTop: isG25Letters
                      ? isMobile
                        ? "6em" // Set the value for both isG25Letters and isMobile true
                        : "5em" // Set the value for isG25Letters true and isMobile false
                      : isMobile
                      ? "8em" // Set the value for isG25Letters false and isMobile true
                      : "6em", // Set the value for both isG25Letters and isMobile false
                  }}
                >
                  <TextField
                    id="filled-basic"
                    label="Type your answer here"
                    sx={{
                      width: "auto",
                    }}
                    value={inputValues[currentQuestionIndex] || ""}
                    onChange={(event) =>
                      handleInputChange(
                        event.target.value,
                        currentQuestionIndex
                      )
                    }
                    InputProps={{
                      readOnly: isViewMode,
                    }}
                  />
                </FormControl>
                {!isViewMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "row",
                      marginTop: "5px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginTop: "16px" }}
                      onClick={handleFormSubmit}
                    >
                      Submit
                    </Button>
                  </Box>
                )}
              </Box>
            </CardContent>
          </Card>
        )}
        <Grid container lg={12} md={12} sm={12} xs={12} justifyContent="center">
          <Pagination
            count={Questions.length}
            shape="rounded"
            sx={{
              marginBottom: "1vh",
              paddingTop: "4%",
            }}
            page={currentQuestionIndex + 1}
            onChange={handlePaginationChange}
          />
        </Grid>
      </LayoutWithIcons>
    </div>
  );
};

export default Layout15;
